/* eslint-disable react/display-name */
//React
import React, { forwardRef, useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
//Assets
import searchIcon from "../../assets/svgs/search.svg";
import edit from "../../assets/svgs/edit-green.svg";
import done from "../../assets/svgs/check-square.svg";
//CSS
import "./inputs.scss";

const Basic = forwardRef(
	(
		{
			label,
			name,
			info,
			required,
			disabled,
			placeholder,
			error,
			customClasses,
			search,
			editable,
			onInput,
			type,
			style,
			value,
			autoComplete,
			onKeyDown,
			min,
			max
		},
		ref
	) => {
		const [err, setErr] = useState(error ?? false);
		const [canEdit, setEdit] = useState(false);
		const [current, setCurrent] = useState(value ? value : "");

		useImperativeHandle(ref, () => ({
			clearInput() {
				const e = { target: { value: "" } };
				onInput(e);
				setCurrent("");
			},
			select(sel) {
				const e = { target: { value: sel } };
				onInput(e);
				setCurrent(sel);
			},
		}));

		const wrapperClasses = [
			"input-wrapper basic",
			err ? "error" : "valid",
			required ? "required" : "not-required",
			disabled ? "disabled" : "enabled",
			search ? "search" : "standard",
			customClasses ?? "",
			editable ?? false ? (canEdit ? "edit" : "read-only") : "default",
		];
		return (
			<div className={wrapperClasses.join(" ")}>
				{label ?? false ? <label htmlFor={name}>{label}</label> : ""}

				<div className="input--inner">
					{search ? (
						<img
							className="search-icon"
							src={searchIcon}
							alt="icon"
						/>
					) : (
						""
					)}
					<input
						type={type ?? "text"}
						name={name}
						required={required}
						disabled={disabled}
						placeholder={placeholder}
						style={style}
						value={current}
						autoComplete={autoComplete}
						min={min}
						max={max}
						onChange={(e) => [onInput(e), setCurrent(e.target.value)]}
						onKeyDown={(e) => {
							if (onKeyDown) {
								onKeyDown(e);
							}
						}}
					/>
					{editable && !canEdit && (
						<button
							type="button"
							className="edit-btn"
							onClick={() => setEdit(!canEdit)}
						>
							<img src={edit} />
						</button>
					)}

					{editable && canEdit && (
						<button
							type="button"
							className="edit-btn"
							onClick={() => setEdit(!canEdit)}
						>
							<img src={done} />
						</button>
					)}
				</div>
			
			{info ?? false ? <div className="input-info">{info}</div> : ""}
		</div>	
	)}
);

Basic.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	required: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
	info: PropTypes.string,
	search: PropTypes.bool,
	placeholder: PropTypes.string,
	error: PropTypes.bool,
	customClasses: PropTypes.string,
	editable: PropTypes.bool,
	onInput: PropTypes.func,
	type: PropTypes.string,
	style: PropTypes.any,
	value: PropTypes.string,
	autoComplete: PropTypes.string,
	onKeyDown: PropTypes.func,
	// Bounds for type="date" / "number" (the picker greys out dates outside them).
	min: PropTypes.string,
	max: PropTypes.string
};

export default Basic;
